module.exports = __webpack_public_path__ + "static/media/heart_message.e4628f70.svg";